module.exports = __webpack_public_path__ + "images/purchase_hero@2x.jpg?a0eafb63";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/purchase_hero@2x.jpg
// module id = 690
// module chunks = 7